import http from '@/config/http.js';
import staticDic from './staticDic.js';
import Vue from "vue";
const state = {
  ...staticDic,
  _DEGREE: [],
  _CURRENT_ACADEMIC: '',
  $OBS_AK: '',
  $OBS_SK: "",
  $OBS_SERVER: '',
  $OBS_BUCKET: '',
  $OBS_PREFIX: 'https://lman-test1.obs.cn-east-3.myhuaweicloud.com/',
}

const getters = {
  getDic(state) {
    return function (type, value) {
      return state[type] ? state[type].reduce((pre, cur) => {
        return cur.value == value ? pre.concat(cur.label) : pre
      }, "") : null
    }
  },
  filterAcademicDegree(state) {
    return
  },
}

const mutations = {
  initDic(state) { },
  updateDepartment(state, data) {
    state._DEPARTMENT = data;
  },
  updateMajor(state, data) {
    state._MAJOR = data;
  },
  updateClass(state, data) {
    state._CLASS = data;
  },
  SET_DIC(state, data) {
    console.log(data)
    Object.keys(data).forEach((key) => {
      // console.log(key)
      let dics = [];
      if (key == 'nation' || key == "political") {
        dics = data[key].map(item => {
          return {
            label: item.name,
            value: item.code
          }
        })
      } else {
        dics = data[key].map(item => {
          return {
            label: item.dictValue,
            value: item.dictKey
          }
        })
      }
      Vue.set(state, ["_" + key.toLocaleUpperCase()], dics);
      // state["_" + key.toLocaleUpperCase()] = data[key];
    });
    state._DEGREE = state._ACADEMICDEGREE.filter(item => {
      return item.value == '01' || item.value == '05' || item.value == '07'
    })
    state._CURRENT_ACADEMIC = state._DEGREE.map(item => item.value).join();
  },
  setObsConfig(state, data) {
    state.$OBS_AK = data.ak;
    state.$OBS_SK = data.sk;
    state.$OBS_SERVER = data.server;
    state.$OBS_BUCKET = data.bucket;
    state.$OBS_PREFIX = data.prefix;
  },
}

const actions = {
  // GET /account/sys/org/getOrgList
  getOrgList({ state }) {
    return new Promise((resolve, reject) => {
      http.get("/account/sys/org/getOrgList").then(res => {
        if (res.code == state.SUCCESS_CODE) {
          state._ORGLIST = res.data.map(item => {
            return {
              label: item.name,
              value: item.id
            }
          })
          resolve(res.code);
        } else {
          resolve(res.code);
        }
      }).catch(err => {
        reject(err)
        console.log(err);
      })
    })
    // return http.get("/account/sys/org/getOrgList")
  },
  // 获取字典
  getDics({ state }, params) {
    return new Promise((resolve, reject) => {
      http.get("/account/sys/dict/listByType", { params: { type: params.type } }).then(res => {
        if (res.code == state.SUCCESS_CODE) {
          state[params.typeName] = res.data.map(item => {
            return {
              label: item.name,
              value: item.code
            }
          })
        }
        resolve(res.code);
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取字典
  getDic({ state }, params) {
    return new Promise((resolve, reject) => {
      http.get("/account/sys/dict/listByType", { params: { type: params.type } }).then(res => {
        if (res.code == state.SUCCESS_CODE) {
          state[params.typeName] = res.data.map(item => {
            return {
              label: item.dictValue,
              value: item.dictKey
            }
          })
        }
        resolve(res.code);
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取字典列表（多个字典）
  getDicList({ commit }, params) {
    return new Promise((resolve, reject) => {
      http.post("/account/sys/dict/listByTypeList", params).then(res => {
        if (res.code == state.SUCCESS_CODE) {
          commit("SET_DIC", res.data);
        }
        resolve(res.code);
      }).catch(err => {
        reject(err)
      })
    })
  },
  // 获取当前学院选项
  getCollegeOptions() {
    let params = {
      isHide: 0
    }
    return new Promise((resolve) => {
      http.get("/account/sys/org/listMyCollege", {
        params: params
      }).then(res => {
        if (res.code == state.SUCCESS_CODE) {
          state._COLLEGE_OPTIONS = res.data.map(item => {
            return {
              label: item.name,
              value: item.id
            }
          })
          state._COLLEGE_ID = state._COLLEGE_OPTIONS.length == 1 ? state._COLLEGE_OPTIONS[0].value : '';
        }
        resolve(res.code);
      }).catch(err => {
        console.error(err);
      })
    })
  },
  // 获取obs配置
  getObsConfig({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      http.get("/account/sys/dict/getObsConfig").then(res => {
        if (res.code == state.SUCCESS_CODE) {
          let data = res.data;
          commit('setObsConfig', data);
        }
        resolve(res.code);
      }).catch(err => {
        reject(err)
      })
    })
  },
}



export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
